(function() {
  var root = document.getElementById('unimech-telegram-chat');

  if (!root) {
    return;
  }

  var storageKey = 'unimechTelegramChatConversation';
  var endpoint = root.getAttribute('data-endpoint') || '';
  var launcher = root.querySelector('.unimech-telegram-chat__launcher');
  var closeButton = root.querySelector('.unimech-telegram-chat__close');
  var form = root.querySelector('.unimech-telegram-chat__form');
  var status = root.querySelector('.unimech-telegram-chat__status');
  var submit = root.querySelector('.unimech-telegram-chat__submit');
  var transcript = root.querySelector('.unimech-telegram-chat__messages');
  var initialFields = root.querySelector('.unimech-telegram-chat__initial-fields');
  var nameInput = root.querySelector('input[name="name"]');
  var contactInput = root.querySelector('input[name="contact"]');
  var messageInput = root.querySelector('textarea[name="message"]');
  var conversation = loadConversation();
  var lastSentAt = 0;
  var pollTimer = null;

  function setOpen(isOpen) {
    root.classList.toggle('is-open', isOpen);

    if (launcher) {
      launcher.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    if (isOpen) {
      pollMessages();
      startPolling();
    } else {
      stopPolling();
    }
  }

  function setStatus(message, type) {
    if (!status) {
      return;
    }

    status.textContent = message || '';
    status.classList.toggle('is-error', type === 'error');
    status.classList.toggle('is-success', type === 'success');
  }

  function loadConversation() {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey) || '{}');
    } catch (error) {
      return {};
    }
  }

  function saveConversation(nextConversation) {
    conversation = nextConversation || {};
    window.localStorage.setItem(storageKey, JSON.stringify(conversation));
    syncConversationState();
  }

  function syncConversationState() {
    var hasConversation = !!conversation.conversationId;
    root.classList.toggle('has-conversation', hasConversation);

    if (initialFields) {
      initialFields.hidden = hasConversation;
    }

    if (nameInput) {
      nameInput.required = !hasConversation;
      nameInput.value = conversation.name || nameInput.value;
    }

    if (contactInput) {
      contactInput.required = !hasConversation;
      contactInput.value = conversation.contact || contactInput.value;
    }
  }

  function getFormValue(formData, key) {
    var value = formData.get(key);
    return typeof value === 'string' ? value.trim() : '';
  }

  function messageUrl() {
    return endpoint.replace(/\/$/, '') + '/messages?conversationId=' + encodeURIComponent(conversation.conversationId);
  }

  function renderMessages(messages) {
    if (!transcript || !Array.isArray(messages)) {
      return;
    }

    transcript.innerHTML = '';

    messages.forEach(function(message) {
      var item = document.createElement('div');
      var bubble = document.createElement('p');
      var meta = document.createElement('span');

      item.className = 'unimech-telegram-chat__message is-' + (message.sender === 'staff' ? 'staff' : 'customer');
      bubble.textContent = message.body || '';
      meta.textContent = message.sender === 'staff' ? 'Unimech Flow' : 'You';
      item.appendChild(bubble);
      item.appendChild(meta);
      transcript.appendChild(item);
    });

    transcript.scrollTop = transcript.scrollHeight;
  }

  function pollMessages() {
    if (!endpoint || !conversation.conversationId) {
      return Promise.resolve();
    }

    return fetch(messageUrl(), {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Messages failed');
        }

        return response.json();
      })
      .then(function(data) {
        if (data && data.ok) {
          renderMessages(data.messages || []);
        }
      })
      .catch(function() {
        stopPolling();
      });
  }

  function startPolling() {
    if (pollTimer || !conversation.conversationId) {
      return;
    }

    pollTimer = window.setInterval(pollMessages, 2000);
  }

  function stopPolling() {
    if (pollTimer) {
      window.clearInterval(pollTimer);
      pollTimer = null;
    }
  }

  if (launcher) {
    launcher.addEventListener('click', function() {
      setOpen(!root.classList.contains('is-open'));
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', function() {
      setOpen(false);
    });
  }

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      setOpen(false);
    }
  });

  if (messageInput) {
    messageInput.addEventListener('keydown', function(event) {
      if (event.key !== 'Enter' || event.shiftKey || event.isComposing) {
        return;
      }

      event.preventDefault();

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        submit.click();
      }
    });
  }

  syncConversationState();

  if (!form) {
    return;
  }

  form.addEventListener('submit', function(event) {
    event.preventDefault();

    if (!endpoint) {
      setStatus('Chat is not connected yet. Please call or email us.', 'error');
      return;
    }

    var now = Date.now();

    if (now - lastSentAt < 2500) {
      setStatus('Please wait a moment before sending another message.', 'error');
      return;
    }

    var formData = new FormData(form);

    if (getFormValue(formData, 'website')) {
      return;
    }

    var payload = {
      conversationId: conversation.conversationId || '',
      name: conversation.name || getFormValue(formData, 'name'),
      contact: conversation.contact || getFormValue(formData, 'contact'),
      message: getFormValue(formData, 'message'),
      pageTitle: root.getAttribute('data-page-title') || document.title,
      pageUrl: window.location.href,
      shopName: root.getAttribute('data-shop-name') || 'Unimech Flow'
    };

    if (!payload.message || (!payload.conversationId && (!payload.name || !payload.contact))) {
      setStatus('Please fill out all fields.', 'error');
      return;
    }

    lastSentAt = now;
    submit.disabled = true;
    setStatus('Sending...', '');

    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Message failed');
        }

        return response.json();
      })
      .then(function(data) {
        if (!data || !data.ok || !data.conversationId) {
          throw new Error('Message failed');
        }

        saveConversation({
          conversationId: data.conversationId,
          name: payload.name,
          contact: payload.contact
        });

        if (messageInput) {
          messageInput.value = '';
          messageInput.focus();
        }

        renderMessages(data.messages || []);
        setStatus('Sent. We will reply here shortly.', 'success');
        startPolling();
      })
      .catch(function() {
        lastSentAt = 0;
        setStatus('Sorry, the message could not be sent. Please call or email us.', 'error');
      })
      .finally(function() {
        submit.disabled = false;
      });
  });
})();
